module.exports = __webpack_public_path__ + "static/media/anuradha_rao.d0880fda.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/prelogin/public/img/testimonial/anuradha_rao.jpg
// module id = 1278
// module chunks = 0